import { render, staticRenderFns } from "./DeleteItemBtn.vue?vue&type=template&id=278bc004"
import script from "./DeleteItemBtn.vue?vue&type=script&lang=js"
export * from "./DeleteItemBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports